import { styled } from '@mui/material';
import React from 'react';
import MessageSvgIcon from '../../../assets/svg/general-setting/MessageSvgIcon';
import Input from '../../../components/Input';

const Container = styled('div')`
  border: 1px solid #e5e5e5;
  padding: 16px;
  border-radius: 8px;
  color: black;
  & > .title {
    display: flex;
    align-items: center;
  }
  & > label {
    padding-top: 15px;
    color: var(--Secondary-60, #a1a1a1);
    font-family: 'Noto Sans';
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
  }
`;

interface AlertNotificationContentProps {
  msgTitle: string | undefined;
  onChange: (msgTitle: string) => void;
}

const AlertNotificationContent: React.FC<AlertNotificationContentProps> = ({
  msgTitle,
  onChange,
}) => {
  return (
    <Container>
      <div className="title">
        <MessageSvgIcon />
        Alert Notification
      </div>
      <label>Title Postfix</label>
      <Input
        sx={{
          width: '100%',
          display: 'block',
          placeholderShown: 'true',
        }}
        value={msgTitle ?? ''}
        placeholder={'Email Title - postfix'}
        onChange={(e) => {
          onChange(e.currentTarget.value);
        }}
      ></Input>
    </Container>
  );
};

export default AlertNotificationContent;
